import { render, staticRenderFns } from "./Adquirentes.vue?vue&type=template&id=47a092d4&scoped=true"
import script from "./Adquirentes.vue?vue&type=script&lang=js"
export * from "./Adquirentes.vue?vue&type=script&lang=js"
import style0 from "./Adquirentes.vue?vue&type=style&index=0&id=47a092d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a092d4",
  null
  
)

export default component.exports